import React, { Component } from 'react'
import get from 'lodash/get'
import range from 'lodash/range'
import { FormattedMessage } from 'react-intl'
import uuidv1 from 'uuid/v1'
import { Link } from 'react-router-dom'

import Pagination from 'components/Pagination'
import EmptyList from 'components/EmptyList'

export default class Table extends Component {
  constructor(props) {
    super(props)
    this.state = {
      columns: Table.configure(props.children),
    }
    this.id = uuidv1()
  }

  static getDerivedStateFromProps(props, state) {
    return {
      columns: Table.configure(props.children)
    }
  }

  static configure = (children) => {
    let columns = children.map(child => {
      return {
        type: child.type,
        ...child.props,
      }
    })

    return columns
  }

  makeTitles = () => {
    let columns = this.state.columns

    return columns.map(({type: Type, ...props}, index) => (
      <Type
        key={index}
        isTitle={true}
        list={this.props.list}
        {...props}
      />
    ))
  }

  makeRow = (item, index) => {
    let columns = this.state.columns
    let rowClassName = this.props.rowClassName || function() { return ''}

    return (
      <tr key={index} className={rowClassName(item)}>
        {columns.map(({type: Type, ...props}, i) => (
          <Type
            key={i}
            item={item}
            index={index}
            list={this.props.list}
            {...props}
          />
        ))}
      </tr>
    )
  }

  makeLoading = () => {
    let columns = this.state.columns

    return (
      <>
        {
          range(5).map(item => (
            <tr key={item}>
              {columns.map(({type: Type, ...props}, i) => {
                return <td key={i} className="cell-pending"><span>{props.mockData || 'Pending'}</span></td>
              })}
            </tr>
          ))
        }
      </>
    )
  }

  getResults = () => {
    const { list = {}, showOnly } = this.props
    if(showOnly && !!get(list, 'results.length')) {
      return list.results.filter((item, index) => index < showOnly)
    }
    return list.results
  }

  render() {
    const { list = {}, rowClassName, isLoading, paginationCount = 100, paginationLimit = 100, paginationOnChange, placeholderComponent, itemsType, routerPage, showOnly, showMorePath, ...restProps } = this.props
    const titles = this.makeTitles()
    const listLength = get(list, 'results.length')
    if(!isLoading && !get(list, 'results.length')) {
      return placeholderComponent ||
      <EmptyList
        placeholderTitle={<FormattedMessage id="tables.isEmpty" />}
      />
    }
    const results = this.getResults()
    return (
      <div>
          <table {...restProps} style={{tableLayout: 'fixed'}} className="table table-hover table-bordered" id={this.id}>
            <thead className="thead-light">
              <tr>
                { titles }
              </tr>
            </thead>
              <tbody>
                {
                  !!get(results, 'length') && !isLoading && results.map(this.makeRow)
                }
                {
                 isLoading && this.makeLoading()
                }
              </tbody>

          </table>
        {
          !showOnly && results && !results.length < paginationCount && paginationOnChange && <div className="row">
            <div className="col">
              <Pagination
                allItemsCount={paginationCount}
                countPerPage={paginationLimit}
                onChange={paginationOnChange}
                disabled={isLoading}
                itemsType={itemsType}
                routerPage={routerPage}
                tableId={this.id}
              />
            </div>
          </div>
        }
        {
          showOnly && listLength > showOnly &&
          <small className="show-only__container">
            <FormattedMessage id="common.shown" />
            {' '}
            <span className="show-only__show-count">{showOnly}</span>
            {' '}
            <FormattedMessage id="common.shownOf" />
            {' '}
            <span className="show-only__pagination-count">{paginationCount}</span>
            {' '}
            <span className="show-only__items-type">{itemsType}</span>.
            {' '}
            {showMorePath && (
              <Link className="show-only__show-more-path link-underline" to={showMorePath}>
                <FormattedMessage id="common.showAll" />
              </Link>
            )}
          </small>
        }
      </div>
    )
  }
}
